import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "count-bubble"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 0,
  class: "overlay top-left fill-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcCounterBubble = _resolveComponent("NcCounterBubble")!
  const _component_XImg = _resolveComponent("XImg")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.link ? 'router-link' : 'div'), {
    draggable: "false",
    tabindex: "1",
    "aria-label": _ctx.title,
    class: "cluster fill-block",
    to: _ctx.target,
    onClick: _ctx.click
  }, {
    default: _withCtx(() => [
      (_ctx.counters && _ctx.data.count)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_NcCounterBubble, {
              count: _ctx.data.count
            }, null, 8, ["count"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "previews fill-block",
        ref: "previews",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickPreview && _ctx.clickPreview(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["img-outer", { plus: _ctx.plus }])
        }, [
          (_openBlock(), _createBlock(_component_XImg, {
            draggable: "false",
            class: "fill-block",
            key: _ctx.data.cluster_id,
            src: _ctx.previewUrl,
            "svg-tag": _ctx.plus,
            onError: _ctx.failed
          }, null, 8, ["src", "svg-tag", "onError"])),
          (_ctx.title || _ctx.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
        ], 2)
      ], 512)
    ]),
    _: 1
  }, 8, ["aria-label", "to", "onClick"]))
}